import { Injectable } from '@angular/core';
import { AppData } from '../providers/app-data';
import { EsriObjectData } from '../providers/esri-object-data';
import { Sublayer } from '../interfaces';
import { SymbolData } from '../providers/symbol-data';

@Injectable()
export class LayerData {

    constructor(private appData: AppData, private esriObjectData: EsriObjectData, private symbolData: SymbolData) {
    }

    getSublayers(): Array<Sublayer> {
        let subLayers: Array<Sublayer> = [];
        let layerId: number = 0;
        this.appData.DynamicSubLayers.forEach( (layer) => {

            let renderer = {
                     type: 'simple',
                     symbol: this.symbolData.getSymbolDefinitionFromGeometry(layer.geometryType, layer.color)
            }
            let query: string = 'select * FROM ' + layer.tableName;
            if (layer.filter) {
                query += ' WHERE ' + layer.filter;
            }
            subLayers.push(
                {
                    'id': layerId,
                    'title': layer.title,
                    'renderer': renderer,
                    'visible': layer.visible,
                    'source': {
                        'type': 'data-layer',
                        'dataSource': {
                            'type': 'query-table',
                            'geometryType': layer.geometryType,
                            'workspaceId': this.appData.settings.workspaceId,
                            'query': query,
                            'oidFields': layer.oidField,
                            'spatialReference': new this.esriObjectData.EsriObjects.SpatialReference(this.appData.settings.spatialReferenceString)
                        }
                    }
                });
                layerId++;
        });
        return subLayers;
    }

}


// WEBPACK FOOTER //
// ./src/providers/layer-data.ts